// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","summary":"summary-1bqfY","route":"route-3BW69","trigger":"trigger-2uylr","trigger__inner":"trigger__inner-1s3FY","slide":"slide-1eYtZ"};